module.exports = __webpack_public_path__ + "search-4539e462/Background_01_1x1_a-268a924c816c338c3a216bc81d280144.svg";